import { Component, Input, inject } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { scoreClassKey } from '../../../lib/shared-value-keys';
import { RightBridgeApiService } from '../../../services/right-bridge-api.service';
import { WarnDialogComponent } from '../../../warn-dialog/warn-dialog.component';
import { ClipboardService } from 'ngx-clipboard';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-expanding-table',
  templateUrl: './expanding-table.component.html',
  styleUrls: ['./expanding-table.component.scss'],
  standalone: false,
})
export class ExpandingTableComponent {
  private location = inject(Location);
  private route = inject(Router);
  private rbs = inject(RightBridgeApiService);
  dialog = inject(MatDialog);
  private clippy = inject(ClipboardService);
  private snacky = inject(MatSnackBar);

  @Input() dataset;
  @Input() actionColumn;
  @Input() evalKey;
  @Input() scoreToolTip;
  scoreClassKey = scoreClassKey;
  holdingsRows = 5;
  loading = false;

  toggleRows(rowProp, value) {
    if (this[rowProp] !== value) {
      this[rowProp] = value;
    } else {
      this[rowProp] = 5;
    }
  }

  nav(location, external = false) {
    if (external) {
      window.open(
        `${this.location.prepareExternalUrl(`/${location}`)}`,
        '_blank'
      );
    } else {
      this.route.navigate([`/${location}`]);
    }
  }

  decryptValue(value: string, title: string) {
    this.loading = true;
    this.rbs.decryptValue(value).subscribe({
      next: resp => {
        this.loading = false;
        if (resp['resultString']) {
          let dialogRef = this.dialog.open(WarnDialogComponent, {
            panelClass: 'warn-dialog',
            data: {
              headline: title,
              content: `Value: ${resp['resultString']}`,
              confirm: 'Copy to Clipboard',
              cancel: 'Close',
              hideCancel: false,
            },
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result === 'continue') {
              this.clippy.copy(resp['resultString']);
              this.snacky.open(`Copied to clipboard!`, 'Close', {
                duration: 4000,
              });
            }
            dialogRef = null;
          });
        }
      },
      error: err => {
        this.loading = false;
        console.error('ERROR: ', err);
        this.snacky.open(
          `Oops! Something went wrong. Please try again.`,
          'Close',
          {
            duration: 4000,
          }
        );
      },
    });
  }
}
